import type { PickingOrderType } from './operations/index.js';
import { PICKING_ORDER_TYPES } from './picking-order-types.js';

/** The Done tab's `types` URL value, "SALES_ORDER,WORK_ORDER", as order types; anything unknown is dropped. */
export function parsePickingTypesParam(value: unknown): PickingOrderType[] {
  if (typeof value !== 'string') return [];
  return PICKING_ORDER_TYPES.filter((orderType) => value.split(',').includes(orderType));
}
